import { FormattedOption } from 'types/dictionaries';

import { Dictionaries } from 'constants/enums';
import statusDropdownSortOrder from 'constants/statusDropdownSortOrder';

const optionsSort = (options: FormattedOption[], sortOrder: string[]) => {
  return [...options].sort((a, b) => {
    const labelA = typeof a.value === 'string' ? a.value : '';
    const labelB = typeof b.value === 'string' ? b.value : '';

    const indexA = sortOrder.indexOf(labelA);
    const indexB = sortOrder.indexOf(labelB);

    if (indexA !== indexB) {
      return (
        (indexA !== -1 ? indexA : Infinity) -
        (indexB !== -1 ? indexB : Infinity)
      );
    }

    return labelA.localeCompare(labelB);
  });
};

export const sortStageAndStatusDropdownOptions = (
  options: FormattedOption[],
  dict: Dictionaries
) => {
  const sortableDictionaries = [
    Dictionaries.ClientStatus,
    Dictionaries.JobStatus,
    Dictionaries.JobseekerStage
  ];

  if (sortableDictionaries.includes(dict)) {
    return optionsSort(
      options,
      statusDropdownSortOrder[dict as keyof typeof statusDropdownSortOrder]
    );
  }
  return options;
};
